export default "__VITE_ASSET__XoFfIsHz__"